import { useState, useEffect } from 'react';
import { chunk } from 'lodash';
import { useToggle } from 'react-use';

import { serial } from '../../shared/util';

export default function useCollectionsFetch (refs, dependencies = [], { detail = false } = {}) {
  const [items, setItems] = useState([]);
  const [isLoading, toggleLoading] = useToggle(false);
  useEffect(() => {
    let cleanedUp = false;
    (async () => {
      toggleLoading(true);
      const data = (await serial(chunk(refs, 10), _ => Promise.all(_.map(_ => _.get()))))
        .flat()
        .flatMap(_ => _.docs)
        .map(_ => ({ id: _.id, ref: _.ref, ..._.data() }));
      if(!cleanedUp) {
        setItems(data);
        toggleLoading(false);
      }
    })();
    return _ => cleanedUp = true;
  }, dependencies);
  return detail ? { isLoading, items, } : items;
};
